(function (jQuery) {
  "use strict";
  var camelize = function (str) {
    return str.replace(/\W+(.)/g, function(match, chr){ return chr.toUpperCase() });
  }

  var checkId = function (id) {
    id = id || 'once';
    if (typeof id !== 'string') {
      throw new TypeError('The jQuery Once id parameter must be a string');
    }
    return camelize('jquery-once-'+id);
  };

  jQuery.fn.removeOnce = function (id) {
    // Filter the elements by which do have the data.
    var idForOnce = checkId(id);
    return this.findOnce(id).each( function(i, element) {
      delete element.dataset[idForOnce]
    });
  }

  jQuery.fn.once = function (id) {

    var idForOnce = checkId(id);

    // Find elements that don't have the jQuery Once data applied to them yet.
    return this.filter( function(index, element) {
      if( element.dataset && typeof element.dataset[idForOnce] === 'undefined' ){
        element.dataset[idForOnce] = true;
        return true;
      }
      return false;
    });
  };

  jQuery.fn.findOnce = function (id) {
    // Filter the elements by which do have the data.
    var idForOnce = checkId(id);

    return this.filter( function(i, element) {
      return typeof element.dataset[idForOnce] !== 'undefined';
    });
  };

})( jQuery);


